"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("../viewUtils/events");
var Command;
(function (Command) {
    function create(title, action) {
        return { title: title, invoke: action };
    }
    Command.create = create;
    function effect(title, effect) {
        var perform = create(title, function () {
            effect();
            return create(title, function () { return perform; });
        });
        return perform;
    }
    Command.effect = effect;
})(Command = exports.Command || (exports.Command = {}));
var NonRememberingHistory = /** @class */ (function () {
    function NonRememberingHistory() {
        this.source = new events_1.EventSource();
        this.events = this.source;
        this.undoStack = [];
        this.redoStack = [];
        this.storeBatch = function () { };
        this.discardBatch = function () { };
    }
    NonRememberingHistory.prototype.reset = function () { };
    NonRememberingHistory.prototype.undo = function () {
        throw new Error('Undo is unsupported');
    };
    NonRememberingHistory.prototype.redo = function () {
        throw new Error('Redo is unsupported');
    };
    NonRememberingHistory.prototype.execute = function (command) {
        command.invoke();
    };
    NonRememberingHistory.prototype.registerToUndo = function (command) { };
    NonRememberingHistory.prototype.startBatch = function (title) {
        return {
            history: this,
            store: this.storeBatch,
            discard: this.discardBatch,
        };
    };
    return NonRememberingHistory;
}());
exports.NonRememberingHistory = NonRememberingHistory;
